import React, { useEffect, useState, useContext } from "react";
import DateFnsUtils from '@date-io/date-fns'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import Validation from "./Validation";
import {ThemeContext} from '../Helper/Context'

const EditProfile = ({onSubmit}) => {
    const {mainState, setMainState} = useContext(ThemeContext);
    const [errors, setErrors] = useState ({errors:true})
    const [formFields, setFormFields] = useState({
        firstName:{
            value:'Karam Murad',
            required: true,
            type:'text'
        },
        lastName:{
            value:'Ebrahim',
            required: true,
            type:'text'
        },
        birthDate:{
            value:'01/01/1990',
            required: true,
            type:'text'
        },
        gender:{
            value:'Male',
            required: true,
            type:'radio'
        },
        phoneNumber:{
            value:'+60122233521',
            required: true,
            type:'text'
        },
        email:{
            value:'karam.murad@alyka.com.au',
            required: true,
            type:'email'
        },
        citizenship:{
            value:'Yemeni',
            required: true,
            type:'text'
        },
        street:{
            value:'14 Avenue, 2203',
            required: true,
            type:'text'
        },
        suburb:{
            value:'West port',
            required: true,
            type:'text'
        },
        postalCode:{
            value:'6000',
            required: true,
            type:'text'
        },
        state:{
            value:'Western Australia',
            required: true,
            type:'text'
        },
        country:{
            value:'Australia',
            required: true,
            type:'text'
        },
        emergencyContactName:{
            value:'John',
            required: true,
            type:'text'
        },
        emergencyContactRelation:{
            value:'Friend',
            required: true,
            type:'text'
        },
        emergencyContactNumber:{
            value:'+60055483547',
            required: true,
            type:'text'
        },
        
    })

    const handleRadioButton = (e) =>{
        if(e === formFields.gender.value)  return true;
    }

    const handleDate = (date) =>{
        setFormFields(prevState =>({
            ...prevState,
            birthDate:{
                ...prevState.birthDate[0], value:date
            }
        }))
    }
    const handleChange = (e) =>{
        setFormFields(prevState =>({
            ...prevState,
            [e.target.name]:{
                ...prevState[e.target.name], value:e.target.value
            }
        }))
    }

    const handleFormSubmit = (e) =>{
        e.preventDefault();
        setErrors(Validation(formFields));
    }

    useEffect(() => {
        if(!errors){
            onSubmit(false, false);
        }
    },[errors]);
    
    return (
        <>
            <p>Please review the current details we have for you, make any changes and confirm. We’ll get to your child next.</p>

            <h2>Your details (Parent/Guardian):</h2>
            {/* <h2>Your personal details</h2> */}
            <div className="form">
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="firstname">First name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="firstname" name="firstName" placeholder="Type your first name" 
                            value={formFields.firstName.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.firstName &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="lastname">Last name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="lastname" name="lastName" placeholder="Type your last name" 
                            value={formFields.lastName.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.lastName &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="dateOfBirth">Date of Birth</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control datepickercontrol">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                            variant="inline"
                            format="MM/dd/yyyy"
                            value={formFields.birthDate.value} 
                            onChange={date => handleDate(date)}
                            />
                        </MuiPickersUtilsProvider>
                        </div>
                        {errors.birthDate &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>                
                <div className="form-row">
                    <div className="form-element">
                        <span className="label">Gender</span>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <span className="radio radio-list-horizontal">
                                <input id="Male" type="radio" name="gender" 
                                checked={handleRadioButton('Male')} 
                                defaultValue="Male" onChange={e => handleChange(e)}/>
                                <label htmlFor="Male">Male</label>

                                <input id="Female" type="radio" name="gender"
                                checked={handleRadioButton('Female')} 
                                defaultValue="Female" onChange={e => handleChange(e)}/>

                                <label htmlFor="Female">Female</label>
                                <input id="Intersex" type="radio" name="gender"
                                checked={handleRadioButton('Intersex')} 
                                defaultValue="Intersex" onChange={e => handleChange(e)}/>
                                <label htmlFor="Intersex">Intersex</label>
                            </span>
                        </div>
                        {errors.gender &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="phoneNumber">Phone number</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="phoneNumber" name="phoneNumber" placeholder="0400 000 000" 
                            value={formFields.phoneNumber.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.phoneNumber &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="email">Email</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="email" name="email" placeholder="Type your email address" 
                            value={formFields.email.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.email &&
                        <span className="EditingFormErrorLabel">Invalid email</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="citizenship">Citizenship</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="citizenship" name="citizenship" placeholder="Type your citizenship" 
                            value={formFields.citizenship.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.citizenship &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <h3>Address details:</h3>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="street">Street</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="street" name="street" placeholder="Type your street name and number" 
                            value={formFields.street.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.street &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="suburb">Suburb</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="suburb" name="suburb" placeholder="Type your suburb" 
                            value={formFields.suburb.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.suburb &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="postalCode">Postal code</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="postalCode" name="postalCode" placeholder="0000" 
                            value={formFields.postalCode.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.postalCode &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="state">State</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="state" name="state" placeholder="Type your state" 
                            value={formFields.state.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.state &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="country">Country</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="country" name="country" placeholder="Type your country" 
                            value={formFields.country.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.country &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <h3>Emergency contact details:</h3>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="emergencyContactName">Emergency contact name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="emergencyContactName" name="emergencyContactName" placeholder="Type emergency contact name" 
                            value={formFields.emergencyContactName.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.emergencyContactName &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="emergencyContactRelation">Emergency contact relation</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="emergencyContactRelation" name="emergencyContactRelation" placeholder="Type your emergency contact relation" 
                            value={formFields.emergencyContactRelation.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.emergencyContactRelation &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="emergencyContactNumber">Emergency contact number</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="emergencyContactNumber" name="emergencyContactNumber" placeholder="0400 000 000" 
                            value={formFields.emergencyContactNumber.value}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.emergencyContactNumber &&
                        <span className="EditingFormErrorLabel">Field required</span>
                        }
                    </div>
                </div>

                <div className="form-row form-row-submit">
                    <div className="form-element">
                        <div className="btn-wrapper">
                        <button className="FormButton btn" value="Done" onClick={(e) => handleFormSubmit(e)} >Done</button>
                        <button className="btn btn-border" onClick={(e) => onSubmit(false, false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    )
}

export default EditProfile